export default __webpack_public_path__ + "static/media/ManualMode.55b06a7f.svg";